export const NAV_ARROWS_CONTROL_STEP = 1
